import {
  ADD_PRODUCT,
  DECREASE_BY_ONE,
  INCREASE_BY_ONE,
  INCREASE_BY_QUANTITY,
} from "./actionType";

export const addProduct = (product) => {
  return {
    type: ADD_PRODUCT,
    payload: product,
  };
};

export const decreaseByOne = (productId) => {
  return {
    type: DECREASE_BY_ONE,
    payload: productId,
  };
};

export const increaseByOne = (productId) => {
  return {
    type: INCREASE_BY_ONE,
    payload: productId,
  };
};

export const increaseByQuantity = (id, quantity) => {
  return {
    type: INCREASE_BY_QUANTITY,
    payload: { id, quantity },
  };
};
